module.exports = __webpack_public_path__ + "static/media/latest-img-3.c84907c2.jpg";